export const PRICE_MODES = [
  { key: "net", label: "Netto", suffix: "" },
  {
    key: "oneri",
    label: "+ Oneri 4% + IVA − R.A. 20%",
    suffix: " + oneri 4% + iva − R.A. 20%",
  },
  { key: "iva22", label: "+ IVA 22%", suffix: " + iva 22%" },
  { key: "exiva", label: "Esclusa IVA", suffix: " (esclusa IVA)" },
];

export const rowTotal = (item) => {
  const qty = Number(item.qty) || 0;
  const price = Number(item.unitPrice) || 0;
  const disc = Number(item.discount) || 0;
  return price * qty * (1 - disc / 100);
};

export const monthlyRowTotal = (item) => {
  if (!item.recurring) return 0;
  const q = Number(item.monthlyQty) || 0;
  const p = Number(item.monthlyPrice) || 0;
  return q * p;
};

export const modeSuffix = (mode) =>
  (PRICE_MODES.find((m) => m.key === mode) || PRICE_MODES[0]).suffix;

export const computeTotals = (quote) => {
  const items = quote.items || [];
  const subtotal = items.reduce((s, it) => s + rowTotal(it), 0);
  const gDisc = Number(quote.globalDiscount) || 0;
  const discounted = subtotal * (1 - gDisc / 100);

  const monthlyTotal = items.reduce((s, it) => s + monthlyRowTotal(it), 0);
  const recurringItems = items.filter(
    (it) => it.recurring && it.name && monthlyRowTotal(it) > 0,
  );

  // per-category totals (one-off / activation)
  const byCategory = {};
  let hasRecurring = false;
  items.forEach((it) => {
    const cat = it.category || "Personalizzata";
    if (!byCategory[cat])
      byCategory[cat] = { total: 0, names: [], recurring: false };
    byCategory[cat].total += rowTotal(it);
    if (it.recurring) {
      byCategory[cat].recurring = true;
      hasRecurring = true;
    }
    const label =
      (Number(it.qty) || 1) > 1 ? `${it.name} (n. ${Number(it.qty)})` : it.name;
    if (it.name) byCategory[cat].names.push(label);
  });

  const computedFinal = gDisc > 0 ? discounted : subtotal;
  const overrideRaw = quote.roundTotal;
  const hasOverride =
    overrideRaw !== undefined &&
    overrideRaw !== null &&
    overrideRaw !== "" &&
    !Number.isNaN(Number(overrideRaw));
  const final = hasOverride ? Number(overrideRaw) : computedFinal;

  return {
    subtotal,
    globalDiscount: gDisc,
    discounted,
    computedFinal,
    final,
    hasOverride,
    hasDiscount: gDisc > 0 || hasOverride,
    hasRecurring,
    monthlyTotal,
    recurringItems,
    byCategory,
  };
};
